__turbopack_context__.v({
  "overlay": "full-screen-loading-module-scss-module__NK9EHa__overlay",
});
